import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Container,
  Tabs,
  Tab,
  Divider,
  colors
} from '@material-ui/core';
import Page from 'src/components/Page';
import Header from './Header';
import Timeline from './Timeline';
import Connections from './Connections';
import Kayit from './Record';
import Plaka from './Plate';
import TechnicianFeedback from './TechnicianFeedback';
import Lokasyon from './Lacation';
import Digiport from './Digiport';
import PersonalDigitalCard from './PersonalDigitalCard';

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    marginTop: theme.spacing(3)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  }
}));

function Profile({ match, history }) {
  const classes = useStyles();
  const { id, tab: currentTab } = match.params;
  const tabs = [
    { value: 'timeline', label: 'Mesajlar' },
    { value: 'connections', label: 'Cİhaz' },
    { value: 'TechnicianFeedback', label: 'Gerİ Bİldİrİm' },    
    { value: 'dijitalKart', label: 'Dİjİtal Kart' },
    { value: 'Plaka', label: 'Plaka' },
    { value: 'Kayit', label: 'Kayıt' },
    { value: 'Lokasyon', label: 'Lokasyon' },
    { value: 'Digiport', label: 'Digiport' }
  ];

  const handleTabsChange = (event, value) => {
    history.push(value);
  };

  if (!currentTab) {
    return <Redirect to={`/profile/${id}/timeline`} />;
  }

  if (!tabs.find((tab) => tab.value === currentTab)) {
    return <Redirect to="/errors/error-404" />;
  }

  return (
    <Page
      className={classes.root}
      title="Kullanıcı"
    >
      <Header />
      <Container maxWidth="lg">
        <Tabs
          onChange={handleTabsChange}
          scrollButtons="auto"
          value={currentTab}
          variant="scrollable"
          textColor="secondary"
          indicatorColor="primary"
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
            />
          ))}
        </Tabs>
        <Divider className={classes.divider} />
        <div className={classes.content}>
          {currentTab === 'timeline' && <Timeline />}
          {currentTab === 'Plaka' && <Plaka />}
          {currentTab === 'dijitalKart' && <PersonalDigitalCard />}
          {currentTab === 'Kayit' && <Kayit />}
          {currentTab === 'connections' && <Connections />}
          {currentTab === 'TechnicianFeedback' && <TechnicianFeedback />}
          {currentTab === 'Lokasyon' && <Lokasyon />}
          {currentTab === 'Digiport' && <Digiport />}
        </div>
      </Container>
    </Page>
  );
}

Profile.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default Profile;
